import {assets, openSelect} from "./_selector-functions";


export function setup_reinitInitial(selfInstance){
  if (selfInstance.$dzsSelectorMain.hasClass('skin-justvisible')) {

    selfInstance.$wrapperMain = selfInstance.$dzsSelectorMain.parent();

    if (selfInstance.$selectInputForm) {
      selfInstance.$selectInputForm = selfInstance.$wrapperMain.find('select').eq(0);
    }

    if (selfInstance.$wrapperMain) {
      selfInstance.$wrapperMain.find('.dzs-select-wrapper-head').unbind('click');
      selfInstance.$wrapperMain.find('.dzs-select-wrapper-head').bind('click', function () {
        openSelect(selfInstance.$selectInputForm);
      })
    }
  }

}


export function setup_determinePlaceholder(selfInstance){
  var o = selfInstance.initOptions;


  if (o.placeholder === 'default') {
    if (selfInstance.$wrapperMain.find('.label-all').length) {
      o.placeholder = selfInstance.$wrapperMain.find('.label-all').eq(0).html();
    }
  }

  if (o.placeholder === 'default') {
    o.placeholder = 'Search ...';
  }
}
export function setup_mainStructure(selfInstance){


  var string_styleWidth = '';


  if (selfInstance.$dzsSelectorMain.get(0).style && selfInstance.$dzsSelectorMain.get(0).style.width !== '' && !isNaN(parseInt(selfInstance.$dzsSelectorMain.get(0).style.width, 10))) {
    string_styleWidth = 'width: ' + parseInt(selfInstance.$dzsSelectorMain.get(0).style.width, 10) + 'px';
  }



  selfInstance.$dzsSelectorMain.wrap('<div class="dzs-select-wrapper fake-input ' + selfInstance.feedElementClass + '" style="' + string_styleWidth + '"></div>');

  selfInstance.$wrapperMain = selfInstance.$dzsSelectorMain.parent();


  if (selfInstance.$dzsSelectorMain.parent().find('select').length) {
    selfInstance.$selectInputForm = selfInstance.$dzsSelectorMain.parent().find('select').eq(0);
  }



  // console.log('selfInstance.$dzsSelectorMain -' , selfInstance.$dzsSelectorMain, selfInstance.$dzsSelectorMain.next());
  if (selfInstance.$wrapperMain.next().hasClass('dzs-style-me-feeder')) {
    selfInstance.$feederObject = selfInstance.$wrapperMain.next();
  }else{
    if(selfInstance.$wrapperMain.find('.dzs-style-me-feeder').length){
      selfInstance.$feederObject = selfInstance.$wrapperMain.find('.dzs-style-me-feeder').eq(0);
    }
  }
  // console.log('selfInstance.$feederObject- ', selfInstance.$feederObject);


}
export function setup_list(selfInstance){

  var aux3 = '<select name="' + selfInstance.$dzsSelectorMain.attr('data-name') + '">';

  for (let i = 0; i < selfInstance.$dzsSelectorMain.children().length; i++) {
    aux3 += '<option value="' + selfInstance.$dzsSelectorMain.children().eq(i).attr('data-value') + '">' + selfInstance.$dzsSelectorMain.children().eq(i).attr('data-value') + '</option>';
  }

  aux3 += '</select>';
  selfInstance.$dzsSelectorMain.after(aux3);
}
export function setup_determineValueCurrent(selfInstance){

  var o = selfInstance.initOptions;

  if (selfInstance.$selectInputForm && selfInstance.$selectInputForm.find(':selected').text()) {
    // val = $(this).find(':selected').text();
    selfInstance.valueCurrent = selfInstance.$selectInputForm.find(':selected').text();
  }


  if (selfInstance.valueCurrent === '') {
    selfInstance.valueCurrent = o.placeholder;
  }


}
export function selector_initial_setup(selfInstance){

  var o = selfInstance.initOptions;

  if (selfInstance.$dzsSelectorMain.hasClass('opener-listbuttons')) {
    o.opener = 'opener-listbuttons';
  }
  if (selfInstance.$dzsSelectorMain.hasClass('opener-bigoptions')) {
    o.opener = 'opener-bigoptions';
  }
  if (selfInstance.$dzsSelectorMain.hasClass('opener-radio')) {
    o.opener = 'opener-radio';
  }
  if (selfInstance.$dzsSelectorMain.hasClass('opener-list')) {
    o.opener = 'opener-list';
  }


  if (selfInstance.$dzsSelectorMain.hasClass('treated') || selfInstance.$dzsSelectorMain.parent().hasClass('dzs-select-wrapper') || selfInstance.$dzsSelectorMain.parent().hasClass('select-wrapper')) {

    selfInstance.isAlreadySetup=true;
  }
}

export function structure_generateWrapperHead(selfInstance){


  var o = selfInstance.initOptions;


  var structure_wrapperHead = '<div class="dzs-select-wrapper-head">';


  if (selfInstance.$wrapperMain.find('.label-curr-selected').length) {
    structure_wrapperHead += '<span class="the-text the-text--curr-selected">' + selfInstance.$wrapperMain.find('.label-curr-selected').eq(0).html() + '</span>';
    // o.placeholder = selfInstance.$wrapperMain.find('.label-all').eq(0).html();
  }

  structure_wrapperHead += '<span class="the-text the-text--placeholder">' + selfInstance.valueCurrent + '</span>';


  if (selfInstance.$wrapperMain.hasClass('skin-charm')) {
    structure_wrapperHead += assets.plus_sign;
  }

  structure_wrapperHead += '</div>';

  return structure_wrapperHead;
}